import getReviews from '@/ajax/shop/product/get-reviews';

/**
 * @module frontAPI/product
 *
 * @description
 * Ajax-обертки для работы с товаром
 */

export default { getReviews };

